<template>
  <div>
    <div v-if="tstate == '已生效' || tstate == '待补充' || tstate === '已关闭' ">
      <My-Span
        style="display: none"
        v-if="titem && titem.alias && titem.alias == 'currentCommission'"
        :label="titem.propertyName"
        :objInput="titem.propertyValueName"
      ></My-Span>
      <My-PhotoPreview
        v-else-if="titem && titem.type && titem.type == 'upload-img'"
        :label="titem.propertyName"
        :objImgUrl="titem.propertyValue"
        :tprop="titem"
        :class="displayCls(item)"
        @childImgNum="childImgNum"
      ></My-PhotoPreview>
      <My-PhotoMultiPreview
        v-else-if="titem && titem.type && titem.type == 'upload-img-multi'"
        :tprop="titem"
        :label="titem.propertyName"
        :class="displayCls(item)"
      ></My-PhotoMultiPreview>
      <div v-else-if="
          titem &&
          titem.rights == 'U' &&
          titem.propertyCode &&
          titem.propertyCode =='102101'&&
          tsubmitValue==true"
          style="dispaly:flex;" >
        <el-form-item class="ss-view-item" :label="titem.propertyName">
          <div style="display:flex;flex-direction: row;">
            <el-select size="small" :placeholder="titem.placeholder" v-model="titem.propertyValueName" :clearable='true' filterable :disabled="false" @focus="getSalesChannels" @change="getSales">
              <el-option v-for="item in List" :key="item.enumKey" :label="item.enumValue"  :value="item.enumValue"></el-option>
            </el-select>
          </div>
          
        </el-form-item>
      </div>
      <My-DateTime
        v-else-if="
          titem &&
          titem.rights == 'U' &&
          titem.propertyCode &&
          titem.propertyCode == '100102'&&
          tsubmitValue==true
        "
        :label="titem.propertyName"
        :placeholder="titem.placeholder"
        :class="displayCls(item)"
        :tprop="titem"
        :objInput="titem.propertyValueName"
        @changeDateTime="childDateVal"
      ></My-DateTime>
      <!-- <div v-else-if="
          titem &&
          titem.rights == 'U' &&
          titem.propertyCode &&
          titem.propertyCode =='100107'&&
          tsubmitValue==true"
          style="dispaly:flex;">
        <el-form-item class="ss-view-item" :label="titem.propertyName" style="box-sizing:border-box;">
          <div style="display:flex;flex-direction: row;">
             <span v-if="titem.propertyValueName.slice(0,2)=='LS'">
               {{titem.propertyValueName.slice(0,2)}}
               </span>
             <span v-if="titem.propertyValueName.slice(0,1)=='E'">{{titem.propertyValueName.slice(0,1)}}</span>
              <el-input v-if="titem.propertyValueName.slice(0,2)=='LS'" :placeholder="titem.placeholder" type="text" style="width:95%" size="mini" :value="titem.propertyValueName.slice(2)" @input="getOrderPrefix">
                {{titem.propertyValueName}}
              </el-input>
              <el-input v-if="titem.propertyValueName.slice(0,1)=='E'" :placeholder="titem.placeholder" type="text" style="width:95%" size="mini" :value="titem.propertyValueName.slice(1)" @input="getOrderPrefix">
                {{titem.propertyValueName}}
              </el-input>
          </div>
        </el-form-item>
      </div> -->
      <div
        v-else-if="
          titem &&
          titem.rights == 'U' &&
          titem.propertyCode &&
          titem.propertyCode=='100108'&&
          tsubmitValue==true">
        <el-form-item :label="titem.propertyName">
          <el-select  @change="changeWfSelct" :placeholder="titem.placeholder" v-model="titem.propertyValueName" :clearable='true' filterable :disabled="false" @blur="getBlur(titem)" style="">
            <el-option v-for="item in titem.data" :key="item.code" :label="item.name"  :value="item.name" ></el-option> 
          </el-select>
        </el-form-item>
      </div>
      <!-- <div v-else-if="
          titem &&
          titem.rights == 'U' &&
          titem.propertyCode &&
          titem.propertyCode =='100310'&&
          tsubmitValue==true"
          style="display:flex;">
        <el-form-item class="ss-view-item" :label="titem.propertyName" style="box-sizing:border-box;">
          <div style="display:flex;flex-direction: row;">
             <span v-model="orderPrefix2">{{orderPrefix2}}</span>
              <el-input :placeholder="titem.placeholder" type="text" style="width:90%" size="mini" :value="titem.propertyValueName.slice(2)" @input="getOrderPrefix">
                {{titem.propertyValueName}}
              </el-input>
          </div>
        </el-form-item>
      </div> -->
      <My-InputSpan
        v-else-if="
          titem &&
          titem.rights == 'U' &&
          titem.propertyCode &&
          tsubmitValue==true
        "
        :label="titem.propertyName"
        :class="displayCls(item)"
        :tprop="titem"
        :objInput="titem.propertyValueName"
        @changeInvoiceNum="childInvoiceNumVal1"
      ></My-InputSpan>
      <!-- &&
        titem.propertyCode!='100108' -->
      <My-Span
        v-else-if="titem"
        :tprop="titem"
        :label="titem.propertyName"
        :objInput="titem.propertyValueName"
        :class="displayCls(item)"
      ></My-Span>
    </div>
    <div v-else>
      <My-Span
        style="display: none"
        v-if="titem && titem.alias && titem.alias == 'currentCommission'"
        :label="titem.propertyName"
        :objInput="titem.propertyValueName"
      ></My-Span>
      <My-PhotoView
        v-else-if="titem && titem.type && titem.type == 'upload-img'"
        :label="titem.propertyName"
        :objImgUrl="titem.propertyValue"
        :class="displayCls(item)"
      ></My-PhotoView>
      <My-PhotoMultiPreview
        v-else-if="titem && titem.type && titem.type == 'upload-img-multi'"
        :tprop="titem"
        :label="titem.propertyName"
        :class="displayCls(item)"
      ></My-PhotoMultiPreview>
      <My-Span
        v-else-if="titem"
        :tprop="titem"
        :label="titem.propertyName"
        :objInput="titem.propertyValueName"
        :class="displayCls(item)"
      ></My-Span>
    </div>
    <!-- <My-SelectForm v-show="item.type=='select'" :placeholder="item.placeholder" :label="item.propertyName"  
        :objSelect="item.propertyValue" v-model="item.propertyCode" :options="item.data" :optionBind="optionBind"></My-SelectForm>    
        <My-DateTime v-show="item.type=='datetime'" :placeholder="item.placeholder" :label="item.propertyName" v-model="item.propertyCode" :dateObj="item.propertyValue"></My-DateTime> 
        <My-InputNumber v-show="item.type=='input-number'" :placeholder="item.placeholder" :label="item.propertyName" v-model="item.propertyCode" :objInputNum="item.propertyValue" ></My-InputNumber>
        <My-SelectAddr v-show="item.type=='select-addr'" :placeholder="item.placeholder" :label="item.propertyName" v-model="item.propertyCode" :objAddr="item.propertyValue" ></My-SelectAddr> -->

    <!-- <div v-else>xxx{{titem}}xxx</div>    -->
  </div>
</template>

<script>
import mySelect from '../mySelect.vue';
export default {
  components: { mySelect },
  data() {
    return {
      optionBind: {
        label: "name",
        value: "code",
      },
      titem: this.item,
      tstate: this.state,
      tsubmitValue: this.submitValue,
      wfAgentBranchList: [],
      salesChannelsProductList: [
        {enumKey:'1',enumName: '线上商城'},
        {enumKey: '0',enumName: '线下商店'}
      ],
      salesChannels:'',
      optionBindsalesChannels:{
        label: 'name',
        value: 'code'
      },
      orderPrefix1: 'LS',
      orderPrefix2: 'LS',
      List: [],
      setValue: '',
      ord:window.sessionStorage.getItem('orderPrefix')
    };
  },
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
    state: {
      type: String,
    },
    submitValue: {
      type: Boolean
    },
    provalue:{
      type: String
    },
    orderPrefix:{
      type: String
    }
  },
  watch: {
    item(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.titem = newVal;
      }
    },
    state(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tstate = newVal;
      }
    }, 
    titem(newVal,oldVal){
      // console.log('newVal',newVal,'old',oldVal)
        if(newVal!==oldVal){
            //console.log('tlist',this.titem)
          this.$emit("changeFormValue",this.titem)
        }
    },
    tsubmitValue(newVal,oldVal){
      if(newVal!=oldVal){
        this.tsubmitValue=newVal
      }
    },
    provalue(newVal,oldVal){
      if(newVal!=oldVal){
        console.log('newVal',newVal,'old',oldVal)
        
        // this.=newVal
        // this.$emit("changeFormValue",this.titem)
      }
    },
    // orderPrefix1(newVal,oldVal){
    //   if(newVal!=oldVal){
    //     console.log('newVal',newVal,'old',oldVal)
    //     if(this.titem.propertyCode=='100108'){
    //       this.$emit("changeFormValue",this.titem)
    //     }
    //   }
    // }
  },
  methods: {
    displayCls: function (prop) {
      // //console.log("item-1", this.item, "tstate-", this.state);
      let cls = "";
      if (prop && prop.phidclass) {
        cls = prop.phidclass;
      } else {
        if (prop && prop.rights && prop.rights == "H") {
          cls = "ss-hid";
        }
      }
      return cls;
    },
    // dateTime
    childDateVal(val){
        this.titem.propertyValue = val
        this.titem.propertyValueName = val
        //console.log('chidl',val)
    },
    // 机器销售单号
    // childInvoiceNumVal(val){
    //     this.titem.propertyValue = val
    //     this.titem.propertyValueName = val
    // },
    childImgNum(val){
      console.log('val',val)
    },
    childInvoiceNumVal1(val){
        this.titem.propertyValue = val
        this.titem.propertyValueName = val
    },
    childInvoiceNumVal2(val){
      console.log('value',val)
        this.titem.propertyValue = val
        this.titem.propertyValueName = val
    },
    changesalesChannelsSelct(val){
      console.log('titem',this.titem,'val',val)
    },
    // 销售渠道
    changeWfSelct(val){
      console.log('value1111',val,'salesChannels',this.salesChannels,'propertyValueName',this.titem.propertyValueName)
      for(let i =0;i<this.salesChannelsProductList.length;i++){
        if(this.salesChannelsProductList[i].name==val){
          this.titem.propertyValue = this.salesChannelsProductList[i].code
          this.titem.propertyValueName = this.salesChannelsProductList[i].name
        }
      }
      if(val=='线上商城'){
        this.orderPrefix1 = 'E'
        this.orderPrefix2 = 'LS'
      }else{
        this.orderPrefix1 = 'LS'
        this.orderPrefix2 = 'LS'
      }
      // window.sessionStorage.setItem('orderPrefix',val)
      // console.log('ssss',window.sessionStorage.getItem('orderPrefix'))
      console.log('线上商城',this.orderPrefix1)
      // debugger
      this.$emit("changeFormValue",this.titem)
      // this.$emit('orderPrefix1Changed',this.orderPrefix1)
      // this.titem.propertyValue
      
    },
    getBlur(val){
      console.log('val----2',val,this.titem)
      // this.getValue()
    },
    // getValue(){
    //   this.setValue = setInterval(() => {
    //     this.blurValue()
    //   }, 500);
    // },
    // blurValue(){
    //   console.log('val----1',this.titem)
    //   console.log('getValue(){',window.sessionStorage.getItem('orderPrefix'))
    //   if(this.titem.propertyCode =='100107'){
    //     this.setValue = ''
    //   }
    // },
    getOrderPrefix(val){
      console.log('item',this.titem)
      console.log('val',val,'order',this.orderPrefix1)
      this.titem.propertyValue = val
      this.titem.propertyValueName = val
      if(val==''){
        if(this.orderPrefix1=='LS'){
          this.titem.propertyValue = 'LS'
          this.titem.propertyValueName = 'LS'
        }else if(this.orderPrefix1 == 'E'){
          this.titem.propertyValue = 'E'
          this.titem.propertyValue = 'E'
        }
        
      }
    },
    getSalesChannels(){
      let url = '/extwarapi/api/product/select'
      let that = this
      this.axios.post(url,'').then((resp)=>{
        console.log(resp)
        if (resp.data.code == '0000') {
          that.List = resp.data.result
        }
      })
    },
    getSales(val){
      console.log('val',val,'titem',this.titem,'this11',this.List)
      if(this.List){
        for(let i =0;i<this.List.length;i++){
          if(val == this.List[i].enumName){
            console.log('this',this.List[i])
            this.titem.propertyValue = this.List[i].enumKey
            this.titem.propertyValueName = this.List[i].enumValue
          }
        }
      }
      
    }
    // 延保销售单号
    // childExtensionNumVal(val){
    //     this.titem.propertyValue = val
    //     this.titem.propertyValueName = val
    // }
  }
};
</script>
